import { usePostsStore } from '@/stores/postsStore';
import { useVariationsFilterStore } from '@/stores/variationsFilterStore';
import { useEarlySupporterStore, ES_FLOW_STORAGE_KEY } from '@/stores/earlySupporterStore';
import { useGatingStore } from '@/stores/gating.store';
import { useShopCartStore, SHOP_CART_STORAGE_KEY } from '@/stores/shopCartStore';

/**
 * SSOT: reset client-side, team-scoped list state (Creator posts + Variations
 * filters) on team switch / God Mode enter-exit / logout so one tenant's
 * filters and cached rows never carry into the next context.
 */
export function resetTeamScopedStores(): void {
  usePostsStore.getState().resetForTeamChange();
  useVariationsFilterStore.getState().clearFilters();
  // Early Supporter draft holds billing PII: drop it from memory and sessionStorage.
  useEarlySupporterStore.setState({ userId: null });
  useEarlySupporterStore.getState().reset();
  useShopCartStore.getState().resetForLogout();
  useGatingStore.getState().resetForTeamChange();
  try {
    sessionStorage.removeItem(ES_FLOW_STORAGE_KEY);
    localStorage.removeItem(SHOP_CART_STORAGE_KEY);
  } catch {
    // storage unavailable
  }
}
